"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
var react_1 = __importDefault(require("react"));
var fullstack_1 = require("@react-fullstack/fullstack");
var socket_io_client_1 = require("socket.io-client");
var Client = /** @class */ (function (_super) {
    __extends(Client, _super);
    function Client() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentDidMount = function () {
            _this.socket = socket_io_client_1.connect(_this.props.host + ":" + _this.props.port, _this.props.socketOptions);
            _this.socket.on("connect", function () {
                _this.socket.emit("request_views_tree");
            });
            _this.forceUpdate();
        };
        _this.componentWillUnmount = function () {
            _this.socket.close();
        };
        _this.render = function () {
            return _this.socket ? (react_1.default.createElement(fullstack_1.Client, { transport: _this.socket, views: _this.props.views })) : (react_1.default.createElement(react_1.default.Fragment, null, " "));
        };
        return _this;
    }
    return Client;
}(react_1.default.Component));
exports.Client = Client;
//# sourceMappingURL=index.js.map